import React, { forwardRef } from 'react';
// eslint-disable-next-line import/named
import { FormControl, InputLabel, MenuItem, Select, SelectProps } from '@mui/material';
import type { SelectChangeEvent } from '@mui/material/Select';
import { Colors } from '../../theme';
import Text from '../text/Text';

interface DropdownProps extends Omit<SelectProps<string | number | null>, 'onChange'> {
    fields: { key: string | number; value: string }[];
    value: string | number | null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onChange: (event: SelectChangeEvent<any>, child: React.ReactNode) => void;
    fullWidth?: boolean;
    label?: string;
    textLabel?: string;
}

const OutlinedDropdown = forwardRef(function _OutlinedDropdown(
    { fields, value, onChange, style, fullWidth = false, label, textLabel, ...props }: DropdownProps,
    ref: React.ForwardedRef<HTMLSelectElement>,
) {
    const form_ctrl_style = fullWidth ? { width: '100%' } : { minWidth: 120 };

    return (
        <FormControl variant="outlined" style={form_ctrl_style}>
            {textLabel ? (
                <Text variant="caption" bold textStyle={{ color: Colors.secondary, letterSpacing: 1 }}>
                    {textLabel.toUpperCase()}
                </Text>
            ) : null}
            {label && !value ? <InputLabel style={{ transform: 'translate(14px, 10px)' }}>{label}</InputLabel> : null}
            <Select
                ref={ref}
                autoWidth
                value={value}
                onChange={onChange}
                style={{
                    padding: 0,
                    borderRadius: 18,
                    borderWidth: 0.1,
                    height: 40,
                    width: '100%',
                    backgroundColor: Colors.white,
                    fontFamily: 'Outfit',
                    color: Colors.primary,
                    ...style,
                }}
                {...props}
            >
                {fields.map((field) => (
                    <MenuItem
                        key={field.key}
                        value={field.key}
                        style={{ width: '100%', fontFamily: 'Outfit', color: Colors.primary }}
                    >
                        {field.value}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
});

export default OutlinedDropdown;
